export class ProductGallery {
    constructor(loader, container, productBlock) {
        this.imagesContainer = container;
        this.productBlock = productBlock;
        this.touchStart = null;
        this.handleOption = this.handleOption.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.handleImages = this.handleImages.bind(this);
        $(this.imagesContainer).find('.featured').on('touchstart', this.handleTouchStart);
        $(this.imagesContainer).find('.featured').on('touchend', this.handleTouchEnd);
        const selectOptions = this.productBlock.find('.variant-select');
        selectOptions.on('change', this.handleImages);
    }

    handleImages(e) {
        const selectedVariant = $(e.target).val(), {productBlock, imagesContainer} = this,
            colorSwatches = $(productBlock).find(`[data-swatches="Color"]`);
        if (colorSwatches.length === 0) {
            return;
        }

        setTimeout(() => {
            const selectedColor = colorSwatches.find('.swatcher-color-option-trigger.active').data('swatch-handle'),
                navItems = imagesContainer.find('nav#strip .image-frame'),
                imageItems = imagesContainer.find('.featured .carousel-inner .carousel-item');
            for (let i = 0; i < navItems.length; i++) {
                const navItem = $(navItems[i]),
                    imageAlt = navItem.data('image-alt');
                if (imageAlt.includes(selectedColor)) {
                    navItem.attr('data-visible', true);
                } else {
                    navItem.attr('data-visible', false);
                }
            }
            let firstAvailableImage = true;
            $(imageItems).find('img').attr('data-visible', true);
            for (let i = 0; i < imageItems.length; i++) {
                const imageItem = $(imageItems[i]),
                    imageAlt = imageItem.find('img').data('image-alt');
                if (imageAlt.includes(selectedColor)) {
                    imageItem.find('img').attr('data-visible', true);
                    // if (firstAvailableImage) {
                    //     firstAvailableImage = false;
                    //     $(imageItems).removeClass('active');
                    //     imageItem.addClass('active');
                    // }
                } else {
                    imageItem.find('img').attr('data-visible', false);
                }
            }
        }, 0);
    }

    handleTouchStart(e) {
        const evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
        const touch = evt.touches[0] || evt.changedTouches[0];
        const touchStart = touch.pageX;
        const height = $('.carousel-item.active').height();
        $(this.imagesContainer).find('.carousel-item').height(height);
        this.touchStart = touchStart;
    }

    handleTouchEnd(e) {
        const evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
        const touch = evt.touches[0] || evt.changedTouches[0];
        const touchEnd = touch.pageX;

        if (typeof this.touchStart === 'undefined' || typeof touchEnd === 'undefined')
            return;

        if (this.touchStart === touchEnd)
            return;

        if (this.touchStart > touchEnd) {
            const currentSlideIndex = this.getCurrentSlideIndex(),
                nextSlideAvailability = this.nextSlideAvailability('left', currentSlideIndex);
            if (nextSlideAvailability === false || nextSlideAvailability === null || typeof nextSlideAvailability === 'undefined') {
                this.firstActiveSlide().trigger('click');
            }
        } else {
            const currentSlideIndex = this.getCurrentSlideIndex(),
                nextSlideAvailability = this.nextSlideAvailability('right', currentSlideIndex);
            if (nextSlideAvailability === false || nextSlideAvailability === null || typeof nextSlideAvailability === 'undefined') {
                this.lastActiveSlide().trigger('click');
            }
        }

        setTimeout(() => {
            $(this.imagesContainer).find('.carousel-item').removeAttr('style');
        }, 1000)
    }

    // return availability of next image in carousel
    nextSlideAvailability(side, index) {
        let nextIndex = null;
        if (side === 'left')
            nextIndex = index + 1;
        else if (side === 'right')
            nextIndex = index - 1;
        const slide = $(this.imagesContainer).find('.featured .carousel-item')[nextIndex],
            isActiveSlide = $(slide).find('img').data('visible');

        return isActiveSlide;
    }

    // get the index of the active image in the carousel
    getCurrentSlideIndex() {
        const slides = $(this.imagesContainer).find('.carousel-item');
        for (let i = 0; i < slides.length; i++) {
            const slide = $(slides[i]);
            if (slide.hasClass('active'))
                return i;
        }
    }

    // get first carousel indicator
    firstActiveSlide() {
        const activeSlide = $(this.imagesContainer).find('.image-frame.data_object[data-visible="true"]').first();
        return activeSlide
    }

    // get last carousel indicator
    lastActiveSlide() {
        const activeSlide = $(this.imagesContainer).find('.image-frame.data_object[data-visible="true"]').last();
        return activeSlide;

    }

    handleOption() {
        const variantOptions = $('.v4-add-to-cart-form .variant-select option');
        for (let i = 0; i < variantOptions.length; i++) {
            const option = $(variantOptions[i]);
            if (option.text().toLowerCase().includes('black')) {
                option.prop('selected', true);
            }
        }
    }

    hasBlack(e) {
        const images = this.imagesContainer.find('nav .image-frame');
        let slideTo = null;
        for (let index = 0; index < images.length; index++) {
            const imageContainer = images[index],
                alt = this.getAlt(imageContainer);
            if (alt) {
                return $(imageContainer);
            }
        }

        return null;
    }

    getAlt(imageContainer) {
        const imageAlt = $(imageContainer).find('img').attr('alt').toLowerCase();
        if (imageAlt.includes('black'))
            return true;
        else
            return false;
    }
}
